import { PARTICIPANT_PREFIX } from 'constants/twilio';

export const getNameParts = (fullName: string) => {
  return fullName.split(' ');
};

export const getFirstName = (fullName: string) => {
  return getNameParts(fullName)[0];
};

export const getLastName = (fullName: string) => {
  const nameParts = getNameParts(fullName);
  if (nameParts.length > 1) return nameParts[nameParts.length - 1];
  return '';
};

export const getAdvocateDisplayName = (twilioIdentity: string | null) => {
  if (twilioIdentity && twilioIdentity.includes(PARTICIPANT_PREFIX.ADVOCATE)) {
    const delimiterIndex = twilioIdentity.indexOf(':');
    return twilioIdentity.slice(delimiterIndex + 1) || '';
  }
  return twilioIdentity;
};
